import "regenerator-runtime/runtime"

import React, { useEffect } from 'react'
import ReactDOM from 'react-dom'
import { Provider, } from 'react-redux'
import { AppContainer } from 'react-hot-loader'
import APIProvider from './APIProvider'

import API from './API'
import createRoutes from './routes'
import App from './App'
import configureStore from './configureStore'
import I18nProvider from './core/I18nProvider'

import { BrowserRouter as Router, withRouter } from 'react-router-dom'

import { MuiProvider } from './core/theme'
import '@formatjs/intl-relativetimeformat/polyfill'
import '@formatjs/intl-relativetimeformat/locale-data/en'
import '@formatjs/intl-relativetimeformat/locale-data/ar'
import { WebsocketsContextProvider } from "queues/WebsocketsContextProvider"
import { ErrorBoundary } from "core/ErrorBoundary"
import { getLanguageOptions } from "i18n/getLanguageOptions"
import { CDNImageContextProvider } from "components/ScaledImage"
import { 
  ActivityContextProvider,
  NativeEventContextProvider,
  SearchContextProvider,
  LanguageSelectionContextProvider,
} from "lib-core"
import { ReduxProfileContextProvider,  } from "profile/useProfile"

// Cache-Control: no-store (see server/render.tsx) keeps Chrome from bfcaching
// the page, but Safari and Firefox restore from bfcache regardless of that
// header. Without this, hitting back after logout (or login) can restore a
// frozen pre-navigation snapshot that no longer matches the real session.
window.addEventListener('pageshow', (event) => {
  if (event.persisted) {
    window.location.reload()
  }
})

let _api: any, _routes: any
const setup = () => {
  if (_api) {
    return { api: _api, routes: _routes }
  }

  const domain = process.env.API_DOMAIN

  const config = {
    root: "/ua",
    domain
  }

  const api = _api || new API(config)
  const routes = createRoutes({ api })

  _api = api
  _routes = routes
  return { api, routes }
}

const target = document.getElementById('root')

let AppContent
const AppWithStore = withRouter((props) => {
  const { api, routes } = setup()

  useEffect(() => {
    const jssStyles = document.querySelector('#jss-server-side')
    if (jssStyles) {
      jssStyles.parentElement.removeChild(jssStyles)
    }
  }, [])

  if (!AppContent) {
    const { history } = props
    const createHistory = () => {
      return history
    }
    const store = configureStore(routes, api, createHistory)
    const options = getLanguageOptions()

    AppContent = (
      <ErrorBoundary api={api}>
        <Provider store={store}>
          <AppContainer>
            <APIProvider api={api}>
              <I18nProvider options={options}>
                <MuiProvider>
                  <WebsocketsContextProvider>
                    <ActivityContextProvider>
                      <CDNImageContextProvider>
                        <SearchContextProvider>
                          <NativeEventContextProvider>
                            <ReduxProfileContextProvider>
                              <LanguageSelectionContextProvider>
                                <App routes={routes} />
                              </LanguageSelectionContextProvider>
                            </ReduxProfileContextProvider>
                          </NativeEventContextProvider>
                        </SearchContextProvider>
                      </CDNImageContextProvider>
                    </ActivityContextProvider>
                  </WebsocketsContextProvider>
                </MuiProvider>
              </I18nProvider>
            </APIProvider>
          </AppContainer>
        </Provider>
      </ErrorBoundary>
    )
  }
  return AppContent
})

const render = (App) => {
  const render = typeof localStorage !== "undefined" && localStorage.language ? ReactDOM.render : ReactDOM.hydrate
  render.call(ReactDOM,
    <Router>
      <AppWithStore />
    </Router>,
    target
  )
}


if (process.env.NODE_ENV === 'development') {
  module.hot.accept('./App', () => {
    const App = require('./App').default

    render(App)
  })
}

; (async () => {
  // await ensureIntlSupport()
  render(App)
})()
